import { ISelectAccount } from '../../pages/login/models/loginModel';
import {
  AUTH_LOGOUT_FAILURE,
  AUTH_LOGOUT_REQUEST,
  AUTH_LOGOUT_SUCCESS,
  AUTH_REGISTER_DEVICE_REQUEST,
  AUTH_REQUEST_OTP_FAILURE,
  AUTH_REQUEST_OTP_REQUEST,
  AUTH_REQUEST_OTP_SUCCESS,
  AUTH_SELECT_ACCOUNT,
  AUTH_VERIFY_OTP_FAILURE,
  AUTH_VERIFY_OTP_REQUEST,
  AUTH_VERIFY_OTP_SUCCESS,
  CHECK_BLACK_LIST,
  CHECK_BLACK_LIST_FAILURE,
  CHECK_BLACK_LIST_SUCCESS,
  GET_GLOBAL_CONFIGS_FAILURE,
  GET_GLOBAL_CONFIGS_REQUEST,
  GET_GLOBAL_CONFIGS_SUCCESS,
  GET_MST_KEY,
  GET_MST_KEY_FAILURE,
  GET_MST_KEY_SUCCESS,
  AUTH_SET_UDF_DETAILS,
  AUTH_TOKEN_REQUEST,
  AUTH_TOKEN_SUCCESS,
  AUTH_TOKEN_FAILURE,
  GET_PDPA_KEY_FAILURE,
  GET_PDPA_KEY_REQUEST,
  GET_PDPA_KEY_SUCCESS,
  USER_GROUP_POLICIES_REQUEST,
  USER_GROUP_POLICIES_FAILURE,
  USER_GROUP_POLICIES_SUCCESS,
  REGISTER_UDF_MYEMPOWER_REQUEST,
  REGISTER_UDF_EMPOWER_REQUEST,
  REGISTER_UDF_PDPA_REQUEST,
  REGISTER_DEVICE_MFA_REQUEST,
  REGISTER_DEVICE_MFA_SUCCESS,
  REGISTER_DEVICE_MFA_FAILURE,
  GET_PDPA_ORDER_FAILURE,
  GET_PDPA_ORDER_REQUEST,
  GET_PDPA_ORDER_SUCCESS,
  AUTH_CHKBLKLIST_SUCCESS,
  GET_EMPOWER_USER_DETAILS_REQUEST,
  GET_EMPOWER_USER_DETAILS_SUCCESS,
  GET_EMPOWER_USER_DETAILS_FAILURE,
  SET_EMPOWER_PATH_REDIRECTED,
  GET_STAFF_LOGIN_DETAILS_REQUEST,
  GET_STAFF_LOGIN_DETAILS_FAILURE,
  GET_STAFF_LOGIN_DETAILS_SUCCESS,
  GET_WAIVER_LOGIN_DETAILS_REQUEST,
  GET_WAIVER_LOGIN_DETAILS_SUCCESS,
  GET_WAIVER_LOGIN_DETAILS_FAILURE,
  AUTH_SET_UDF_TOKEN_DETAILS,
  UPDATE_EMPOWER_USER_DETAILS_FAILURE,
  UPDATE_EMPOWER_USER_DETAILS_REQUEST,
  UPDATE_EMPOWER_USER_DETAILS_SUCCESS
} from './actionTypes';
import {
  AuthRegisterDeviceRequest,
  AuthRequestOtp,
  AuthRequestOtpSuccess,
  AuthRequestOtpFailure,
  AuthVerifyOtp,
  AuthVerifyOtpSuccess,
  AuthVerifyOtpFailure,
  checkBlacklisted,
  checkBlacklistedSuccess,
  checkBlacklistedFailure,
  IMSTKey,
  IMSTKeyFailure,
  IMSTKeySuccess,
  IGlobalConfigsFailure,
  IGlobalConfigsRequest,
  IGlobalConfigsSuccess,
  IPdpaValidateFailure,
  IPdpaValidateRequest,
  IPdpaValidateSuccess,
  IPdpaOrderFailure,
  IPdpaOrderRequest,
  IPdpaOrderSuccess
} from './models/types';

export const registerDevice = {
  request: (): AuthRegisterDeviceRequest => ({
    type: AUTH_REGISTER_DEVICE_REQUEST
  })
};

export const getOTP = {
  request: (email): AuthRequestOtp => ({
    type: AUTH_REQUEST_OTP_REQUEST,
    email
  }),
  success: (data): AuthRequestOtpSuccess => ({
    type: AUTH_REQUEST_OTP_SUCCESS,
    data
  }),
  failure: (error): AuthRequestOtpFailure => ({
    type: AUTH_REQUEST_OTP_FAILURE,
    error
  })
};

export const verifyOTP = {
  request: (challengeToken: string, otp: string, emailId: string): AuthVerifyOtp => ({
    type: AUTH_VERIFY_OTP_REQUEST,
    challengeToken,
    otp,
    emailId
  }),
  success: (data): AuthVerifyOtpSuccess => ({
    type: AUTH_VERIFY_OTP_SUCCESS,
    data
  }),
  failure: (error): AuthVerifyOtpFailure => ({
    type: AUTH_VERIFY_OTP_FAILURE,
    error
  })
};

export const selectAccount = (account: ISelectAccount) => ({
  type: AUTH_SELECT_ACCOUNT,
  account
});

export const checkBlacklistedbrn = {
  request: (brn, originalOpt, checkCall = false): checkBlacklisted => ({
    type: CHECK_BLACK_LIST,
    brn,
    originalOpt,
    checkCall
  }),
  success: (data): checkBlacklistedSuccess => ({
    type: CHECK_BLACK_LIST_SUCCESS,
    data
  }),
  failure: (error): checkBlacklistedFailure => ({
    type: CHECK_BLACK_LIST_FAILURE,
    error
  })
};

export const getConfiguredMstKeyValuesByBrn = {
  request: (brn): IMSTKey => ({
    type: GET_MST_KEY,
    brn
  }),
  success: (data): IMSTKeySuccess => ({
    type: GET_MST_KEY_SUCCESS,
    data
  }),
  failure: (error): IMSTKeyFailure => ({
    type: GET_MST_KEY_FAILURE,
    error
  })
};

export const logout = {
  request: () => ({ type: AUTH_LOGOUT_REQUEST }),
  success: () => ({ type: AUTH_LOGOUT_SUCCESS }),
  failure: (error) => ({ type: AUTH_LOGOUT_FAILURE, error })
};

export const getGlobalConfigs = {
  request: (): IGlobalConfigsRequest => ({
    type: GET_GLOBAL_CONFIGS_REQUEST
  }),
  success: (data): IGlobalConfigsSuccess => ({
    type: GET_GLOBAL_CONFIGS_SUCCESS,
    data
  }),
  failure: (error): IGlobalConfigsFailure => ({
    type: GET_GLOBAL_CONFIGS_FAILURE,
    error
  })
};

export const setUDFDetails = (data) => ({ type: AUTH_SET_UDF_DETAILS, data });
export const setUDFTokenDetails = (data) => ({ type: AUTH_SET_UDF_TOKEN_DETAILS, data });

export const getUdfToken = {
  request: () => ({ type: AUTH_TOKEN_REQUEST }),
  success: () => ({ type: AUTH_TOKEN_SUCCESS }),
  failure: () => ({ type: AUTH_TOKEN_FAILURE })
};

export const getPDPAValidation = {
  request: (key, pdpaType): IPdpaValidateRequest => ({ type: GET_PDPA_KEY_REQUEST, key, pdpaType }),
  success: (data): IPdpaValidateSuccess => ({ type: GET_PDPA_KEY_SUCCESS, data }),
  failure: (error): IPdpaValidateFailure => ({ type: GET_PDPA_KEY_FAILURE, error })
};

export const getPDPAOrderDetails = {
  request: (key): IPdpaOrderRequest => ({ type: GET_PDPA_ORDER_REQUEST, key }),
  success: (data): IPdpaOrderSuccess => ({ type: GET_PDPA_ORDER_SUCCESS, data }),
  failure: (error): IPdpaOrderFailure => ({ type: GET_PDPA_ORDER_FAILURE, error })
};

export const getUserGroupPolicies = {
  request: () => ({ type: USER_GROUP_POLICIES_REQUEST }),
  success: (data) => ({ type: USER_GROUP_POLICIES_SUCCESS, data }),
  failure: (error) => ({ type: USER_GROUP_POLICIES_FAILURE, error })
};

export const registerUdfMyempower = {
  request: () => ({ type: REGISTER_UDF_MYEMPOWER_REQUEST })
};

export const registerUdfEmpower = {
  request: () => ({ type: REGISTER_UDF_EMPOWER_REQUEST })
};

export const registerUdfPdpa = {
  request: () => ({ type: REGISTER_UDF_PDPA_REQUEST })
};

export const registerDeviceMfa = {
  request: () => ({ type: REGISTER_DEVICE_MFA_REQUEST }),
  success: (data) => ({ type: REGISTER_DEVICE_MFA_SUCCESS, data }),
  failure: (error) => ({ type: REGISTER_DEVICE_MFA_FAILURE, error })
};

export const getCheckBlacklist = {
  success: (xPageKey) => ({ type: AUTH_CHKBLKLIST_SUCCESS, xPageKey })
};

export const getEmpowerUserDetails = {
  request: () => ({ type: GET_EMPOWER_USER_DETAILS_REQUEST }),
  success: (data) => ({ type: GET_EMPOWER_USER_DETAILS_SUCCESS, data }),
  failure: (error) => ({ type: GET_EMPOWER_USER_DETAILS_FAILURE, error })
};

export const updateEmpowerUserDetails = {
  request: () => ({ type: UPDATE_EMPOWER_USER_DETAILS_REQUEST }),
  success: (data) => ({ type: UPDATE_EMPOWER_USER_DETAILS_SUCCESS, data }),
  failure: (error) => ({ type: UPDATE_EMPOWER_USER_DETAILS_FAILURE, error })
};

export const setEmpowerPathRedirection = (data) => ({ type: SET_EMPOWER_PATH_REDIRECTED, data });
export const getStaffLoginDetails = {
  request: () => ({ type: GET_STAFF_LOGIN_DETAILS_REQUEST }),
  success: (data) => ({ type: GET_STAFF_LOGIN_DETAILS_SUCCESS, data }),
  failure: (error) => ({ type: GET_STAFF_LOGIN_DETAILS_FAILURE, error })
};

export const getWaiverLoginDetails = {
  request: (key) => ({ type: GET_WAIVER_LOGIN_DETAILS_REQUEST, key }),
  success: (data) => ({ type: GET_WAIVER_LOGIN_DETAILS_SUCCESS, data }),
  failure: (error) => ({ type: GET_WAIVER_LOGIN_DETAILS_FAILURE, error })
};

export const setRefreshTokenLoading = (value) => ({ type: 'SET_REFRESH_TOKEN_LOADING', value });
